import { useTimer } from "react-timer-hook"

const Timer = ({ expiryTime, onExpire }) => {

    const { hours, seconds, minutes } = useTimer({ expiryTimestamp: expiryTime, onExpire: () => onExpire() })
    return (
        <span style={{ fontWeight: "bold" }}>{hours} hrs : {minutes} mins : {seconds} secs time left</span>
    )
}

export default Timer;